import type {FC} from "react";

const MatchRatioBar: FC<{label: string; ratio: number}> = ({label, ratio}) => (
  <div className="flex items-center gap-3">
    <span className="text-neutral-grey-dark w-28 shrink-0 text-xs">{label}</span>
    <div className="bg-neutral-grey-lightest h-2 flex-1 overflow-hidden rounded-full">
      <div className="bg-success-herbal h-full rounded-full" style={{width: `${ratio * 100}%`}} />
    </div>
    <span className="text-neutral-grey-dark w-10 text-right text-xs font-semibold">{Math.round(ratio * 100)}%</span>
  </div>
);

export default MatchRatioBar;
